import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'customCol' })
export class ListCustomColumnPipe implements PipeTransform {
  transform(value: any, args: string): string {
    try {
      const path = args.split('.')
      let tmpObj = { ...value }
      let result: any = ''
      for (let x = 0; x < (path.length || 0); x++) {
        tmpObj = tmpObj[path[x]]
        if (x === path.length - 1) {
          result = tmpObj
        }
      }
      return `${result}`
    } catch (e) {
      return 'ERROR'
    }
  }
}
